import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { config } from '../config';

export const userManager = new UserManager({
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid email profile',
  automaticSilentRenew: true,
  // Store tokens in memory — NOT localStorage
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});
